<style scoped>
label.title {
  font-weight: bold;
  text-transform: uppercase;
  font-family: Montserrat, sans-serif, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
  color :#373e46;
  margin-bottom: 0 !important;
}

label span {
  color: red;
}
</style>

<template>
  <div v-show="shouldShow()" class="mb-3">
    <div>
      <label :for="item.label" class="title">
        <Lock v-if="item.response_private" />
        {{item.label | multitranslate}}
        <span v-if="item.required">*</span>
      </label>

      <p v-if="item.instructions">
        {{item.instructions | multitranslate}}
      </p>
    </div>

      <div class="custom-control custom-radio" v-for="anOption in options" :key="anOption">

        <input type="radio"
          class="custom-control-input"
          :name="item.label"
          :id="item.id + '-' +anOption"
          v-model="content"
          :value="anOption"
          :required="item.required === 1" />


        <label :for="item.id + '-' +anOption" class="custom-control-label">
          {{anOption | multitranslate}}
        </label>
      </div>
      
  </div>
</template>


<script>
import AbstractForm from './AbstractForm.vue';
export default {
  extends: AbstractForm,
  name: 'Radio',
  props: ['item'],
  data: function() {
    return {
      content:''
    }
  },
  created() {},
  methods: {
    
  }
}
</script>
